// 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import AddIcon from '@mui/icons-material/Add';
// import { Add_regions_Action } from '../../Redux/Actions/Regions_Action';
// import { Notify } from '../../Utility/Notify';
// import { Col } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { CircularProgress, useTheme } from '@mui/material';

// export const AddRegions = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const dispatch = useDispatch();
//   const [regions, setregions] = useState('');
//   const [loading, setloading] = useState(true);
//   const [addLoading, setaddLoading] = useState(false);

//   const namechange = (e) => {
//     setregions(e.target.value);
//   };

//   // add regions========================================================
//   const onsubmitadd = async (e) => {
//     e.preventDefault();

//     if (regions === '') {
//       Notify('error', 'Please Enter a Name', 'error');
//       return;
//     } else {
//       setloading(true);
//       setaddLoading(true);
//       await dispatch(
//         Add_regions_Action({
//           name: regions,
//         }),
//       );
//       setloading(false);
//       setaddLoading(false);
//     }
//   };
//   const res_add = useSelector((state) => state.AllRegions.Region);

//   useEffect(() => {
//     if (loading === false) {
//       if (res_add && res_add.status === 201) {
//         Notify('success', 'successfully Added', 'success');
//       }
//       setregions('');
//     }
//   }, [loading]);

//   // =====================================================================
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/Regionsandareas'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/Regionsandareas'
//         : '/'; // fallback

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//             <div className='mx-3'>Regions</div>
//             <a style={{textDecoration:'none'}} href='/Regionsandareas' className='goback'>{"<<"} Go To Regions </a>
//         </div> */}

//           <div className="d-flex">
//             <div>
//               <div>
//                 <Link to={homeRoute} style={{ textDecoration: 'none', color: '#0F7687' }}>
//                   <span style={{ fontWeight: 'bold', color: '#102dff' }}>Home Regions</span>
//                 </Link>

//                 <KeyboardDoubleArrowRightIcon />

//                 <span style={{ color: '#666' }}>Add Region</span>
//               </div>{' '}
//             </div>
//           </div>

//           {/* inputes of add Region */}

//           <div
//             style={{
//               padding: '20px',
//               borderRadius: '15px',
//               background: mode === 'dark' ? '#333' : '#fff',
//             }}
//           >
//             <Row>
//               <div style={{ marginTop: '20px' }}>
//                 <label for="Name">Regions Name *</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={namechange}
//                   value={regions}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Name"
//                   placeholder="Region Name.."
//                 />
//               </div>
//             </Row>

//             {/* <div onClick={onsubmitadd} style={{textAlign:'center',background:'#0F7687'}}  className='addnewclient'  type="submit" ><AddIcon/> Add Regions</div> */}
//             <Row
//               className="d-flex justify-content-center"
//               style={{ width: '100%', marginTop: '10px', textAlign: 'center' }}
//             >
//               <div
//                 onClick={!addLoading ? onsubmitadd : null}
//                 className="addnewclient"
//                 style={{
//                   background: '#102dff',
//                   pointerEvents: addLoading ? 'none' : 'auto',
//                   opacity: addLoading ? 0.6 : 1,
//                   cursor: addLoading ? 'not-allowed' : 'pointer',
//                   width: '50%',
//                 }}
//                 type="submit"
//               >
//                 {addLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <AddIcon /> Add Regions
//                   </>
//                 )}
//               </div>
//             </Row>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };














//20-5- 2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { Add_regions_Action } from '../../Redux/Actions/Regions_Action';
import { Notify } from '../../Utility/Notify';
import AddIcon from '@mui/icons-material/Add';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const AddRegions = () => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sidebarWidth = useSidebarWidth();

  const [userlogin,   setUserlogin]   = useState(null);
  const [regions,     setRegions]     = useState('');
  const [loading,     setLoading]     = useState(true);
  const [addLoading,  setAddLoading]  = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  const homeRoute =
    userlogin?.data?.role === 'Admin'    ? '/Regionsandareas'
  : userlogin?.data?.role === 'Marketer' ? '/Regionsandareas'
  : '/';

  const onsubmitadd = async (e) => {
    e.preventDefault();
    if (!regions.trim()) return Notify('error', 'Please Enter a Name', 'error');
    setLoading(true);
    setAddLoading(true);
    await dispatch(Add_regions_Action({ name: regions.trim() }));
    setLoading(false);
    setAddLoading(false);
  };

  const res_add = useSelector((state) => state.AllRegions.Region);
  useEffect(() => {
    if (loading === false) {
      if (res_add?.status === 201) {
        Notify('success', 'successfully Added', 'success');
        setRegions('');
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link
          to={homeRoute}
          style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}
        >
          Regions & Areas
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Add New Region</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px', fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px', letterSpacing: '-0.4px',
            }}>
              Add New Region
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Add a new region to the CRM database
            </p>
          </div>

          {/* field */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Region Name *</label>
            <input
              style={inputStyle}
              value={regions}
              onChange={(e) => setRegions(e.target.value)}
              type="text"
              placeholder="e.g. Downtown, Marina, Jumeirah"
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={(e) => { if (e.key === 'Enter') onsubmitadd(e); }}
              autoFocus
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full region name as it will appear across the system
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!addLoading ? onsubmitadd : null}
              disabled={addLoading}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: addLoading ? 'not-allowed' : 'pointer',
                opacity: addLoading ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!addLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {addLoading
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Adding…</span></>
                : <><AddIcon sx={{ fontSize: 17 }} /><span>Add Region</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate(homeRoute)}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};